/**
 * Per-mutation retry-safety policy — v.1-D §7.9.
 *
 * Mutations listed here are idempotent (natural-key dedupe or patch / no-op
 * semantics) and the error-toast Retry button is therefore safe to surface
 * without warning the user. All other mutations must NOT auto-retry; the
 * `useMutationWithToast` hook consults `isRetrySafe(mutationName)` to gate
 * the Retry action.
 *
 * Whitelist source: v.1-D §7.9 (cross-team quarterly review per CLAUDE.md §6.8).
 *
 * Ported verbatim by T304 from `frontend-v2/src/lib/mutation-policy.ts`.
 */

export const RETRY_SAFE_MUTATIONS: ReadonlySet<string> = new Set([
  'alerts.acknowledgeAlert',
  'alerts.acknowledgeAllUnacknowledged',
  'alerts.resolveAlert',
  'alerts.resolveChannelAlerts',
  'automations.setEnabled',
  'templates.incrementUsage',
  'channels.updateChannel', // patch semantics — re-sending same values is a no-op
  'organizations.updateOrg', // patch semantics
  'organizations.updateMemberRole', // patch semantics
  'alertPreferences.upsert',
]);

export function isRetrySafe(mutationName: string): boolean {
  return RETRY_SAFE_MUTATIONS.has(mutationName);
}
